export default __webpack_public_path__ + "static/media/female.721cc0fe.png";